import React, { PureComponent } from 'react'
import ReportItem from './components/recommendationItem'
import { Container, Row, Col } from 'reactstrap'
import { complianceRecommendations } from '../../utils/mockData'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const recommendationData = complianceRecommendations()

class Recommendation extends PureComponent {
  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized')
  }

  render () {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className='page-title'>Posture Recommendations</h3>
            <h3 className='page-subhead subhead'>All your compliance recommendations details in one view!</h3>
          </Col>
        </Row>
        <Row>
          {
            recommendationData.map(report => {
              return <ReportItem key={uuid()} title={report.title} img={report.img} data={report.data} />
            })
          }
        </Row>
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(withRouter(Recommendation))



// WEBPACK FOOTER //
// ./src/components/recommendations/Recommendations.js